import React from 'react';

import { Container } from '@mui/material';

import { angularizeWithProviders } from '../../../shared/providers';
import { PageTitle } from '../../../shared/components/ui-components/PageTitle/PageTitle';
import { ReportTable } from './containers/ReportTable/ReportTable';
import { ReportDownloadModal } from './containers/ReportDownloadModal/ReportDownloadModal';

const NgzCoachReportsList = () => {
  return (
    <Container>
      <PageTitle title="Reports" />
      <ReportTable />
      <ReportDownloadModal />
    </Container>
  );
};

angularizeWithProviders(NgzCoachReportsList, 'ngzCoachReportsList', {});

export { NgzCoachReportsList };
